import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Select, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import TableComplex from "../../../vapor/tableComplex";
import "./style.css";
import { columnsIntrastat } from "./columns";
import ArticleIntrastatRow from "./articleIntrastatRow";
import DrawerAddNomenclaturaIntrastat from "./addNomenclatura";
import uuidv4 from "uuid/v4";
import { FormattedMessage } from "react-intl";
import numeral from "numeral";
import { useDispatch, useSelector } from "react-redux";
import { createNomenclature, deleteNomenclature, getIntrastatList, updateNomenclature } from "../../../../store/actions/precog/intrastat";
import moment from "moment/moment";
import { VaporDatePicker } from "../../../vapor";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../../constants/constants";

const Option = Select.Option;
const Intrastat = ({ docTotal, draftId, isSaleInvoice, docDate }) => {

  const dispatch = useDispatch();
  const intrastatList = useSelector(state => state.precog.intrastatList?.list);
  const periodicity = useSelector(state => state.precog.intrastatList?.periodicity);

  const [draggingFrom, setDraggingFrom] = useState(false);
  const [allowDrag, setAllowDrag] = useState(false);
  const [lockDrag, setLockDrag] = useState(false);
  const [droppingOn, setDroppingOn] = useState(null);
  const [drawerNomenclatura, setDrawerNomenclatura] = useState(false);
  const [panelOpen, setPanelOpen] = useState("");
  const [declaredTotal, setDeclaredTotal] = useState(0);
  const [list, setList] = useState([]);

  const nomenclatureList = [{ code: 1, name: "Nomenclatura beni", type: "GOOD" }, { code: 2, name: "Nomenclatura servizi", type: "SERVICE" }];
  
  useEffect(() => {
    dispatch(getIntrastatList(draftId));
  }, []);

  useEffect(() => {
    if (!intrastatList) return;
    setList(intrastatList);
  }, [intrastatList]);  

  useEffect(() => {
    if (!list || list.length === 0) return;
    getDeclaredTotal();
    // getExcludedIntraTotal();
  }, [list]);

  const onDragArticleEnd = (dropData) => {
    let contiToUpdate = [...list];
    let rowToRemove = contiToUpdate.find(x => x.id === dropData.from);
    let rowToAdd = contiToUpdate.find(x => x.id === dropData.to);
    if (rowToRemove && rowToAdd) {
      rowToRemove.articles.splice(rowToRemove.articles.indexOf(dropData.article), 1);
      rowToRemove.total = Math.round((rowToRemove.total - dropData.article.total) * 100) / 100;
      if (!rowToAdd.articles) {
        rowToAdd.articles = [];
      }
      rowToAdd.articles.push(dropData.article);
      rowToAdd.total = Math.round((rowToRemove.total + dropData.article.total) * 100) / 100;
    }
    setList(contiToUpdate);
    return;
  };

  const onAddItemClick = () => {
    let items = [];
    list.map(item => {
      return items.push(item);
    });
    items.push({
      id: null,
      name: "",
      total: 0,
      checkConto: false,
      postingDate: docDate
    });
    setList(items);
  };

  const renderSummary = () => {
    let itemsRet = [
      <div key={"conti-intrastat-add"} className="conti-intrastat-add" onClick={() => onAddItemClick()}>
        <FontAwesomeIcon icon={["fas", "plus-circle"]} />
        <FormattedMessage id="preCog.intrastatTab.addRow" />
      </div>
    ];

    return itemsRet;
  };

  const onRemoveConto = (id) => {
    let items = [];
    list.map(item => {
      if (item.id !== id) {
        items.push(item);
      }
      return items;
    });
    getExcludedIntraTotal(items);
    if (id !== null) {
      dispatch(deleteNomenclature(draftId, id));
    }
    setList(items);
  };

  const onChangeNomenclatura = (id, val) => {
    let items = [];
    let currentItem = nomenclatureList.find(el => el.code === val);
    list.map(item => {
      if (item.id === id) {
        items.push({ ...item, name: currentItem.name, code: currentItem.code, type: currentItem.type });
      } else {
        items.push(item);
      }
      return items;
    });
    if (id === null) {
      let currentElement = list.find(el => el.id === null);
      dispatch(createNomenclature(draftId, {
        name: currentItem.name,
        type: currentItem.type,
        total: currentElement.total,
        postingDate: currentElement.postingDate
      })).then(res => items.find(el => el.id === id).id = res);
    } else {
      dispatch(updateNomenclature(
        draftId, id, {name: currentItem.name, type: currentItem.type}
      ));
    }
    setList(items);
  };

  const onChangeAmount = (id, val) => {
    let newList = [...list];
    if (newList.find(el => el.id === id)) {
      let itemIndex = newList
        .map(item => item.id)
        .indexOf(id);
      newList[itemIndex].total = val.target.value
        ? parseFloat(val.target.value.replace(".", "").replace(",", "."))
        : 0;
    } else {
      let itemIndex = newList
        .map(item => item.id)
        .indexOf(null);
      newList[itemIndex].total = val.target.value
        ? parseFloat(val.target.value.replace(".", "").replace(",", "."))
        : 0;
    }
    setList(newList);
  };

  const getExcludedIntraTotal = (items) => {
    let newTotal = docTotal;
    let newList = [...list];
    if (items) {
      items.map(el => {
        if (el.name !== "EXCLUDED_AMOUNT") {
          newTotal = newTotal - el.total;
        }
        return newTotal;
      });
    } else {
      list.map(el => {
        if (el.name !== "EXCLUDED_AMOUNT") {
          newTotal = newTotal - el.total;
        }
        return newTotal;
      });
    }
    newList.find(el => el.name === "EXCLUDED_AMOUNT").total = newTotal;
    setList(newList);
  };

  const getDeclaredTotal = () => {
    let newTotal = 0;
    list.map(el => {
      if (el.name !== "EXCLUDED_AMOUNT") {
        newTotal = newTotal + el.total;
      }
      return newTotal;
    });
    setDeclaredTotal(newTotal);
  };

  const renderTableRow = (conto, key) => {
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];
    return {
      key: conto.id || `rowID_${key}`,
      conto: conto,
      name:
        <div className={"conti-intrastat-nomenclatura-cell"}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer"
            }}
            onClick={() => {
              if (conto.id === panelOpen) {
                setPanelOpen("");
              } else {
                setPanelOpen(conto.id);
              }
            }}
          >
            {conto.articles && conto.articles.length !== 0 && (
              <FontAwesomeIcon
                icon={[
                  "far",
                  conto.id === panelOpen ? "chevron-up" : "chevron-down"
                ]}
                className="conti-intrastat-expand-icon"
              />
            )}
          </div>
          {/* <InputAntd className="dbx-preCog-input-conto" value={conto.nomenclatura}  onChange={(val) => onChangeNomenclatura(conto.rowId, val.target.value)} /> */}
          <Select
            showSearch
            optionFilterProp="children"
            getPopupContainer={trigger => trigger.parentNode}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            className={"conti-intrastat-select"}
            disabled={conto.name === "EXCLUDED_AMOUNT"}
            onSelect={value => onChangeNomenclatura(conto.id, value)}
            value={conto.name === "EXCLUDED_AMOUNT" ? "Esclusi da intrastat" : conto.name}
            placeholder="Sel. destinazione"
            style={{ width: "100%" }}
            suffixIcon={null}
          >
            {nomenclatureList.map(el => (
              <Option
                key={"articles-accordion-select_" + uuidv4()}
                value={el.code}
              >
                {el.name}
              </Option>
            ))}
          </Select>
          {conto.type && <div
            className="conti-intrastat-type-container"
            style={{
              background:
                conto?.type === "GOOD" ? "#711423" : "#fc4e3d"
            }}
          >
            {conto?.type === "GOOD" ? "B" : "S"}
          </div>}
          {conto.name !== "EXCLUDED_AMOUNT" && <div onClick={() => setDrawerNomenclatura(conto)} className="conti-intrastat-open-drawer-icon"><FontAwesomeIcon icon={["far", "external-link-square-alt"]} /></div>}
        </div>,
      total: (
        <NumberFormat
          displayType={"input"}
          thousandSeparator={"."}
          decimalSeparator={","}
          className="conti-intrastat-total"
          placeholder="0 €"
          suffix={"€"}
          disabled={conto.name === "EXCLUDED_AMOUNT"}          
          value={conto.total !== 0 ? numeral(conto.total).format("0,0.00") : undefined}
          decimalScale={2}
          onBlur={() => {
            getExcludedIntraTotal();
            getDeclaredTotal();
            let amountToChange = list.find(el => el.id === conto.id).total;
            if (conto.id !== null) {
              dispatch(updateNomenclature(
                draftId, conto.id, { total: amountToChange }
              ));
            }
          }}
          onChange={val => { onChangeAmount(conto.id, val); }}
        />
      ),
      postingDate: conto.name !== "EXCLUDED_AMOUNT" ?
        <VaporDatePicker
          format={dateFormatList}
          getPopupContainer={(trigger) => trigger.parentNode}
          onChange={(date) => {
            let newList = [...list];
            if (newList.find(el => el.id === conto.id)) {
              let itemIndex = newList
                .map(item => item.id)
                .indexOf(conto.id);
              newList[itemIndex].postingDate = date;
            } else {
              let itemIndex = newList
                .map(item => item.id)
                .indexOf(null);
              newList[itemIndex].postingDate = date;
            }
            setList(newList);
            if (conto.id !== null) {
              dispatch(updateNomenclature(
                draftId, conto.id, { postingDate: date }
              ));
            }
          }}
          className="conti-intrastat-date"
          value={conto.postingDate ? moment(conto.postingDate) : undefined}
        /> : null,
      rectificationDate: conto.rectificationDate ?
        <Tooltip placement="bottom" title={`Modifica intrastat ${moment(conto.rectificationDate).format(DATE_FORMAT_FOR_DISPLAY)}`} color={"#005075"}>
          <div className="intrastat-rectification-check"><FontAwesomeIcon icon={["fas", "check-circle"]} /></div> 
        </Tooltip> :
        null,
      removeConto: (conto.name !== "EXCLUDED_AMOUNT" ?
        <div style={{ padding: 8, textAlign: "end" }} onClick={() => onRemoveConto(conto.id)}>
          <FontAwesomeIcon
            className="preCog-detail-remove-icon"
            icon={["far", "trash-alt"]}
          />
        </div> : null
      )
    };
  };

  const buildDataSource = () => {
    return list?.map((conto, key) => renderTableRow(conto, key));
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {drawerNomenclatura &&
        <DrawerAddNomenclaturaIntrastat
          onClose={() => {
            setDrawerNomenclatura(false);
            dispatch(getIntrastatList(draftId));
          }}
          visible={drawerNomenclatura}
          conto={drawerNomenclatura}
          isSaleInvoice={isSaleInvoice}
          draftId={draftId}
        />}
      <div style={{ display: "flex", justifyContent: "space-between" }} >
        <div className="intrastat-periodicity">
          <div>
              Periodicità
          </div>
          <div style={{fontWeight: "normal"}}>
            {periodicity ? <FormattedMessage id={`preCog.intrastatTab.${periodicity.toLowerCase()}`} /> : ""}
          </div>
        </div>
        <div style={{ display: "flex", gap: 50, justifyContent: "end" }}>
          <div>
            <div className="intrastat-amount-titles">
              <FormattedMessage id="preCog.intrastatTab.total" />
            </div>
            <div className="intrastat-amount-totals">
              {`${numeral(declaredTotal).format("0.0,")} €`}
            </div>
          </div>
          <div>
            <div className="intrastat-amount-titles">
              <FormattedMessage id="preCog.intrastatTab.difference" />
            </div>
            <div className="intrastat-amount-totals" style={{ color: "#005075" }}>
              {`${list?.find(el => el.name === "EXCLUDED_AMOUNT") ? numeral(list.find(el => el.name === "EXCLUDED_AMOUNT").total).format("0.0,") : 0} €`}
            </div>
          </div>
        </div>
      </div>
      <div className="conti-contabili-table-new" style={{ marginTop: 16 }}>
        <TableComplex
          summary={renderSummary()}
          dataSource={buildDataSource()}
          columns={columnsIntrastat(draggingFrom, setDroppingOn)}
          // rowClassName={(record, index) => { return record.conto.id === droppingOn ? " precog-intrastat-highlighted" : ""; }}
          expandable={{
            expandIconColumnIndex: -1,
            expandedRowKeys: [panelOpen],
            expandedRowRender: record => {
              if (!record.conto.articles) {
                return null;
              }
              return record.conto.articles.map((el, index) => {
                return (
                  <ArticleIntrastatRow
                    key={`ArticleIntrastatRow_${index}`}
                    contoId={record.conto.id}
                    article={el}
                    // hasProbability={hasProbability}
                    onArticleDrag={(val) => { setDroppingOn(null); onDragArticleEnd(val); }}
                    allowDrag={allowDrag}
                    setAllowDrag={setAllowDrag}
                    lockDrag={lockDrag}
                    setLockDrag={setLockDrag}
                    draggingFrom={draggingFrom}
                    setDraggingFrom={setDraggingFrom}
                    droppingOn={droppingOn}
                  />
                );
              });
            }
            // rowExpandable: record => record.name !== "Not Expandable"
          }}
        />
      </div>
    </div>
  );
};

export default Intrastat;
